import { useThree } from '@react-three/fiber'
import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import { RolodexTilesPlugin, useSiteViewContext } from 'features/siteView'
import {
  CompassGizmo,
  ReorientationPlugin,
  TilesFadePlugin,
  TilesPluginR3f,
  TilesRendererR3f,
} from 'gecko-3d-tiles-renderer'
import {
  TilesRenderer,
  TilesRendererEventMap,
} from 'gecko-3d-tiles-renderer/src/three/TilesRenderer'
import { useSiteModelContext } from 'pages/siteView/siteMap/contexts/SiteModelContext'
import React, { useMemo } from 'react'

export const TilesRendererWrapper: React.FC = () => {
  const { setTilesMatrix, setTilesEllipsiod } = useSiteViewContext()
  const { siteModel } = useSiteModelContext()

  const tilesRendererRef =
    React.useRef<TilesRenderer<TilesRendererEventMap> | null>(null)

  const size = useThree((state) => state.size)

  const { authorizedAxios } = useGeckoAuth()
  const { ROLODEX_URL } = useRuntimeVariables()

  const compassMargin: [number, number] = React.useMemo(
    () => [25, size.height - 50],
    [size]
  )

  const rolodexPluginOptions = useMemo(() => {
    return {
      entryID: siteModel.id,
      rootPath: 'vricon_3dtiles',
      axios: authorizedAxios,
      rolodexURL: ROLODEX_URL,
    }
  }, [siteModel, authorizedAxios, ROLODEX_URL])

  const onTilesLoad = () => {
    const tilesEllipsoid = tilesRendererRef.current?.ellipsoid
    const tilesFrame = tilesRendererRef.current?.group.matrixWorld
    if (tilesEllipsoid && tilesFrame) {
      setTilesEllipsiod(tilesEllipsoid)
      setTilesMatrix(tilesFrame)
      tilesRendererRef.current?.removeEventListener(
        'tiles-load-end',
        onTilesLoad
      )
    }
  }

  return (
    <TilesRendererR3f
      url={'tileset.json'}
      ref={(ref) => {
        tilesRendererRef.current = ref
        ref?.addEventListener('tiles-load-end', onTilesLoad)
      }}>
      <TilesPluginR3f plugin={RolodexTilesPlugin} args={rolodexPluginOptions} />
      <TilesPluginR3f plugin={TilesFadePlugin} fadeDuration={500} />
      <TilesPluginR3f plugin={ReorientationPlugin} />
      <CompassGizmo margin={compassMargin} />
    </TilesRendererR3f>
  )
}
